// URL forms follow each provider's documented schemes:
// - Apple Maps URL Scheme Reference: when `ll` is set, `q` is used as the pin label.
// - Google Maps URLs API (`api=1`): the documented stable form; a label is not
//   possible from coordinates alone (would require a place_id).
// Zoom is intentionally left to provider defaults.
export function buildMapsHref(
  isIOS: boolean,
  fullAddress: string,
  latitude: number | null,
  longitude: number | null,
  label: string
): string {
  if (latitude != null && longitude != null) {
    return isIOS
      ? `https://maps.apple.com/?ll=${latitude},${longitude}&q=${encodeURIComponent(label)}`
      : `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  }
  const encodedAddress = encodeURIComponent(fullAddress);
  return isIOS
    ? `https://maps.apple.com/?q=${encodedAddress}`
    : `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
}
